import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import style from "./StoreManagement.module.css";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Container from "layouts/container/Container";
import clsx from "classnames";
import StoreManagementDetail from "./StoreManagementDetail";


function StoreManagement() {
    const [storeList, setStoreList] = useState();
    const [sortedStoreList, setSortedStoreList] = useState([]);
    const [expandedStore, setExpandedStore] = useState(null);
    const [detailData, setDetailData] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        requester.findAllStores((result) => {

            setStoreList(result.data);
            
        })
    }, [])

    useEffect(() => {
        // 백엔드에서 받아온 데이터를 createDateTime 기준으로 정렬
        const sortedByDateTime = storeList?.filter(data => data.id !== 'root').sort((a, b) =>

            new Date(a.createDateTime).getTime() - new Date(b.createDateTime).getTime()
        );

        setSortedStoreList(sortedByDateTime);
    }, [storeList]);

    const onDetailClick = (data) => {
        navigate("/admin/store/management/detail", { state: { data: data } })
    }
    // 기기 상태를 시각적인 요소로 변환하는 함수
    const renderMachineStatus = (machines) => {
        return machines.map((machine, index) => (
            <div
                key={index}
                style={{
                    width: '25px',
                    height: '25px',
                    borderRadius: "50%",
                    backgroundColor: machine.heartbeat ? 'green' : 'red', // heartbeat 유무에 따른 색상
                    padding: '0 2px',
                }}
            ></div>
        ));
    };
    const toggleExpand = (storeId) => {
        setExpandedStore(prevState => prevState === storeId ? null : storeId);
    };


    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <div>
                            <P size={40} font={"gmarketSansBold"} color={"black"}>상점 관리</P>
                        </div>
                    </FlexChild>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                        {sortedStoreList && sortedStoreList.map((store) => (
                            <div className={style.Card} key={store.id}>
                                <P size={20}>{store.storeName}</P>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <HorizontalFlex gap={10}>
                                            <FlexChild width={"max-content"}>
                                                <P>키오스크 :</P>
                                            </FlexChild>
                                            <FlexChild>
                                                {renderMachineStatus(store.machines.filter(m => m.orderNo === 1 || m.orderNo === 2))}
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                    <FlexChild justifyContent={"flex-end"}>
                                        <CustomButton text={expandedStore === store.id ? '닫기' : '열기'}
                                            onClick={(e) => {
                                                e.stopPropagation(); // 이벤트 버블링 방지
                                                toggleExpand(store.id);
                                            }} />
                                    </FlexChild>
                                </HorizontalFlex>
                                {expandedStore === store.id && (
                                    <StoreManagementDetail data={store} />
                                )}
                            </div>
                        ))}
                    </div>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default StoreManagement;